import { createSelector, createSlice } from '@reduxjs/toolkit';
import * as R from 'ramda';
import http from 'utils/http';
import { createSnack } from 'snackbar/snackbarSlice';

const initialState = {
  affiliatesList: [],
  error: '',
  pending: false,
};

const reducers = {
  fetchAffiliatesError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  fetchAffiliatesPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  fetchAffiliatesSuccess(state, { payload }) {
    return R.assoc('affiliatesList', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'affiliates',
  reducers,
});

const { fetchAffiliatesPending, fetchAffiliatesSuccess, fetchAffiliatesError } = actions;

// Selectors
const affiliatesListSelector = state => state.pto.affiliates.affiliatesList;
const recipientNameSelector = state => state.pto.createPto.recipientIdName;

export const currentAffiliateSelector = createSelector(
  affiliatesListSelector,
  recipientNameSelector,
  (affiliates, recipientName) =>
    affiliates.find(({ customerIdName }) => customerIdName === recipientName)
);

export const affiliateOptionsSelector = createSelector(affiliatesListSelector, affiliates =>
  affiliates.map(({ customerIdName, customerNameShort }) => ({
    label: customerNameShort,
    value: customerIdName,
  }))
);

export const getAffiliatesOptions = createSelector(affiliatesListSelector, affiliates =>
  affiliates.map(affiliate => ({
    dataCompanyId: affiliate.dataCompanyId,
    label: affiliate.customerNameShort,
    value: affiliate.customerIdName,
  }))
);

// Actions
let fetchController;
export function fetchAffiliates(params = {}) {
  if (fetchController) fetchController.abort();
  fetchController = new AbortController();
  const { signal } = fetchController;

  return (dispatch, getState) => {
    dispatch(fetchAffiliatesPending(true));
    return http
      .get('/product-transfer-orders/get-affiliates', { params }, { signal })
      .then(res => {
        dispatch(fetchAffiliatesPending(false));
        dispatch(fetchAffiliatesError(''));
        if (!R.equals(res.data, getState().pto.affiliates.affiliatesList)) {
          dispatch(fetchAffiliatesSuccess(res.data));
        }
      })
      .catch(error => {
        if (error?.response?.data?.title) {
          dispatch(
            createSnack({
              message: error.response.data.title,
              options: { variant: 'error' },
            })
          );
        }
      });
  };
}

export default reducer;
